import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    chapters: {},
    items: {},
    dialogues: [],
    conditions: {
      mute: { text: "_m_off", check: false },
      speedrun: { text: "Keine Zeit", check: false },
    },
    events: {},

    tips: [
      { current: 0, custom: 0 },
      "Ludwig schaut manchmal instinktiv die Gegenstände an, die ihm weiterhelfen. Wenn du nicht weiter weisst, achte darauf, wo Ludwig hinschaut. ",
      "Ludwig hat Kopfschmerzen – manchmal reagiert er nicht sofort.",
      "Hier könnte Ihre Werbung stehen",
      "Ludwig ist schnell verwirrt, wenn zu viele Stimmen in seinem Kopf gleichzeitig sprechen",
      "Hilf Ludwig dabei, seinen nächsten Fall zu lösen: ludwig-arts.ch/start",
      "Ludwig versteht dich besser, wenn du deutlich und direkt ins Mikrofon sprichst",
      "Du kannst jederzeit nach Hinweisen fragen",
    ],

    FakeAction: {},
    initiated: false,
    dialogue: null,
    subdialogue: null,
    selected: null,
    talkingTo: null,
    inventoryPosition: 1,
    busy: false,
    talking: false,
    video: false,
    fakeActionMode: false,
    fakeActionVideos: null,
    nextFakeAction: false,
    event: false,
    idle: "",
    loading: true,
    installed: true,
    timer: 0,
    music: null,
    arrow: false,
    arrowDefault: false,
    muted: false,
    chapter: 1,
    waitingForMo: false,
    skipContinue: false,
    currentLine: 0,
    line: "",
    //Browsergame
    userCommand: "",
    lastTaken: "",
    narrate: null,
    continuer: true,
    playerNext: true,
    userCombineWith: null,
  },
  mutations: {
    loadData(state, payload) {
      state.chapters = payload.chapters;
      state.items = payload.items;
      state.dialogues = payload.dialogues;
      state.conditions = payload.conditions;
      state.events = payload.events;
      state.FakeAction = payload.FakeAction;
      state.initiated = true;
    },
    updateUserCommand(state, c) {
      //for browsergame
      // mutate state
      state.userCommand = c;
    },
    currentDialogue(state, d) {
      // mutate state
      state.dialogue = d;
    },
    currentSubdialogue(state, d) {
      // mutate state
      state.subdialogue = d;
    },
    resetCurrentLine(state, renew = false) {
      state.currentLine = renew ? 0 : -1;
    },
    nextLine(state) {
      state.currentLine++;
    },
    setLine(state, l) {
      state.line = l;
    },
    select(state, id) {
      // mutate state
      state.selected = id;
    },
    talk(state, name) {
      // mutate state
      state.talkingTo = name;
    },
    condition(state, val) {
      // mutate state
      state.conditions[val.id].check = val.bool;
      if ("add" in state.conditions[val.id]) {
        state.conditions[state.conditions[val.id].add].count++;
        if (
          state.conditions[state.conditions[val.id].add].count ==
          state.conditions[state.conditions[val.id].add].target
        ) {
          state.conditions[state.conditions[val.id].add].check =
            state.conditions[state.conditions[val.id].add].action;
        }
      }
      if ("sub" in state.conditions[val.id]) {
        state.conditions[state.conditions[val.id].sub].count--;
        if (
          state.conditions[state.conditions[val.id].sub].count ==
          state.conditions[state.conditions[val.id].sub].target
        ) {
          state.conditions[state.conditions[val.id].sub].check =
            state.conditions[state.conditions[val.id].sub].action;
        }
      }
      /*
      let items = state.inventory.filter((i) => i.isCondition == val.id);
      if (items.length > 0) {
        for (let item of items) {
          item.inMantu = val.bool;
        }
      }
      items = state.inventory.filter((i) => "onCondition" in i);
      for (let item of items) {
        if ("in" in item.onCondition) {
          if (
            item.onCondition.in.filter(
              (i) => i[0] == val.id && i[1] == val.bool
            ).length > 0
          )
            item.inMantu = true;
        }
        if ("out" in item.onCondition) {
          if (
            item.onCondition.out.filter(
              (i) => i[0] == val.id && i[1] == val.bool
            ).length > 0
          )
            item.inMantu = false;
        }
      }*/
    },
    wait(state) {
      state.busy = true;
    },
    continue(state) {
      if (state.waitingForMo == true) {
        state.waitingForMo = false;
      } else {
        state.busy = false;
      }
    },
    waitForMo(state) {
      state.waitingForMo = true;
      //  state.busy = true;
    },
    notWaitingForMo(state) {
      state.waitingForMo = false;
      //  state.busy = true;
    },
    talking: (state, bool) => {
      state.talking = bool;
    },
    load(state) {
      state.loading = true;
    },
    loaded(state) {
      state.loading = false;
      state.arrow = state.arrowDefault;
    },
    install(state) {
      state.installed = true;
    },
    startInstall(state) {
      state.installed = false;
    },
    setTimer: (state, min) => {
      state.timer = min;
    },
    playVideo: (state, url) => {
      state.video = url;
    },
    startFakeAction: (state, fakeaction) => {
      let faID = fakeaction[0];
      let faVideos = fakeaction[1];
      let videos = {};
      console.log("set fake action mode:", fakeaction);
      state.fakeActionMode = faID;

      for (let i in state.FakeAction[faID].videos) {
        if (faVideos.includes(i)) {
          videos[state.FakeAction[faID].videos[i].layer] = {
            video: state.FakeAction[faID].videos[i].video,
            loop: state.FakeAction[faID].videos[i].loop,
            layer: state.FakeAction[faID].videos[i].layer,
            onend: state.FakeAction[faID].videos[i].onend,
          };
          state.fakeActionVideos = videos;
        }
      }
    },
    stopFakeAction: (state) => {
      state.fakeActionMode = false;
      state.fakeActionVideos = null;
    },
    prepareFakeAction: (state, fakeaction) => {
      state.nextFakeAction = fakeaction;
    },
    unsetNextFakeAction: (state) => {
      state.nextFakeAction = false;
    },
    playEvent: (state, url) => {
      state.event = url;
    },
    stopVideo: (state) => {
      state.video = false;
      state.event = false;
    },
    setNarrate(state, n) {
      state.narrate = n;
    },
    setIdle: (state, idle) => {
      state.idle = idle;
    },
    increaseInventoryPosition(state) {
      state.inventoryPosition++;
    },
    toggleArrow: (state) => {
      state.arrow = !state.arrow;
    },
    toggleArrowDefault: (state) => {
      state.arrowDefault = !state.arrowDefault;
    },
    setChapter: (state, id) => {
      for (let chapter in state.chapters) {
        state.chapters[chapter].active = false;
      }
      state.chapters[id].active = true;
      state.chapter = id;
    },
    mute: (state) => {
      state.muted = true;
    },
    toggleMute: (state) => {
      state.muted = !state.muted;
    },
    skip: (state, bool) => {
      state.skipContinue = bool;
    },
    take: (state, item) => {
      state.items[item].inMantu = true;
      state.inventoryPosition++;
      state.lastTaken = item;
      state.items[item].position = state.inventoryPosition;
    },
    remove: (state, item) => {
      state.items[item].inMantu = false;
    },
    continuer(state) {
      state.continuer = state.continuer ? false : true;
    },
    playerNext(state) {
      state.playerNext = state.playerNext ? false : true;
    },
    userCombineWith(state, item) {
      state.userCombineWith = item;
    },
  },
  actions: {
    setMusic({ state }, music) {
      if (state.music != null) {
        state.music.pause();
        state.music.currentTime = 0;
      }
      state.music = new Audio(require("../assets/audio/" + music));
      state.music.loop = true;
      state.music.volume = 0.2;
      state.music.play();
    },
    loadData({ commit }, data) {
      commit("loadData", data);
    },
  },
  modules: {},
  getters: {
    initiated: (state) => {
      return state.initiated;
    },
    userCommand: (state) => {
      return state.userCommand;
    },
    speaker: (state) => {
      return Object.values(state.items)
        .filter((item) => {
          if ("inMantu" in item) {
            if (item.inMantu == true) {
              return true;
            }
          }
          if ("chapter" in item) {
            if (item.chapter.constructor === Array) {
              for (let i in item.chapter) {
                if (item.chapter[i] == state.chapter) {
                  return true;
                }
              }
            } else {
              return item.chapter == state.chapter;
            }
          }
        })
        .sort(function (a, b) {
          let textA = a.text.toUpperCase();
          let textB = b.text.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
      //  return state.speaker.filter((item) => item.chapter == state.chapter);
    },
    music: (state) => {
      return state.music;
    },
    dialogues: (state) => {
      return state.dialogues;
    },
    currentLine: (state) => {
      return state.currentLine;
    },
    line: (state) => {
      return state.line;
    },
    subdialogue: (state) => {
      return state.subdialogue;
    },
    conditions: (state) => {
      return state.conditions;
    },
    currentDialogue: (state) => {
      return state.dialogue;
    },
    anydialogue: (state) => {
      if (state.subdialogue != null) {
        return state.subdialogue;
      }
      return state.dialogue;
    },
    selected: (state) => {
      return state.selected;
    },
    talkingTo: (state) => {
      return state.talkingTo;
    },
    items: (state) => {
      return state.items;
    },
    itemsArray: (state) => {
      return Object.entries(state.items);
    },
    itemByName: (state) => (name) => {
      let id = false;
      Object.entries(state.items).forEach(([key, item]) => {
        if (item.text == name) {
          id = key;
        }
      });
      return id;
    },
    inventory: (state) => {
      return Object.values(state.items)
        .filter((i) => i.inMantu)
        .sort((a, b) =>
          a.position < b.position ? -1 : a.position > b.position ? 1 : 0
        );
    },
    inventoryPosition: (state) => {
      return state.inventoryPosition;
    },
    isBusy: (state) => {
      return state.busy;
    },
    isTalking: (state) => {
      return state.talking;
    },
    loading: (state) => {
      return state.loading;
    },
    tips: (state) => {
      return state.tips;
    },
    installed: (state) => {
      return state.installed;
    },
    time: (state) => {
      return state.timer;
    },
    video: (state) => {
      return state.video;
    },
    fakeActionMode: (state) => {
      return state.fakeActionMode;
    },
    fakeActionVideos: (state) => {
      return state.fakeActionVideos;
    },
    nextFakeAction: (state) => {
      return state.nextFakeAction;
    },
    event: (state) => {
      return state.event;
    },
    idle: (state) => {
      return state.idle;
    },
    chapters: (state) => {
      return state.chapters;
    },
    arrow_r: (state) => {
      if (
        !state.isBusy &&
        !state.dialogue &&
        !state.loading &&
        state.installed &&
        !state.talkingTo
      ) {
        // condition check sauber lösen
        return state.arrow ? !state.items.arrow.inMantu : false; //return state.arrow ? !state.conditions[18].check : false;
      }
      return false;
    },
    arrow_default: (state) => {
      return state.arrowDefault;
    },
    currentMusic: (state, getters) => {
      if (state.muted) {
        return "_.mp3";
      }
      if (state.loading) {
        if (state.installed) {
          return "loading.mp3";
        }
        return "_.mp3";
      }
      //TODO: simplify
      for (let id in state.chapters) {
        if (state.chapters[id].active == true) {
          console.warn(state.chapters[id].music);
          if ("onCondition" in state.chapters[id].music) {
            for (let onCondition of state.chapters[id].music.onCondition) {
              let check = [];

              Object.entries(onCondition.conditions).forEach(([key, value]) => {
                check.push(getters.checkCondition(key, value));
              });
              if (check.every((e) => e === true) && check.length > 0) {
                return onCondition.music;
              }
            }
          }
          return state.chapters[id].music.default;
        }
      }
    },
    muted: (state) => {
      return state.muted;
    },
    waitingForMo: (state) => {
      return state.waitingForMo;
    },
    events: (state) => {
      return state.events;
    },
    skip: (state) => {
      return state.skipContinue;
    },
    //Browsergame
    isBrowserGame: () => {
      return process.env.VUE_APP_BROWSERGAME === "true";
    },
    lastTaken: (state) => {
      return state.lastTaken;
    },
    narrate: (state) => {
      return state.narrate;
    },
    continuer: (state) => {
      return state.continuer;
    },
    playerNext: (state) => {
      return state.playerNext;
    },
    userCombineWith: (state) => {
      return state.userCombineWith;
    },
    checkCondition: (state) => (condition, check) => {
      if (condition in state.conditions) {
        if (state.conditions[condition].check == check) {
          return true;
        }
      } //check if condition is item
      if (condition in state.items) {
        if (state.items[condition].inMantu == check) {
          return true;
        }
      }
    },
  },
});
